import { useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { crmErr, money, toCents } from "./helpers";
import ContactPicker from "./ContactPicker";
import { DateField } from "../common/DateField";

const eur = (c) => (c ? String(c / 100).replace(".", ",") : "");

// «Modifica trattativa»: name, opportunity value, stage, contact. Revenue and cash are NOT edited here (table cells / «Rettifica»).
export default function EditDealDialog({ tid, deal, contact, stages = [], onClose, onSaved }) {
  const api = useApi();
  const auto = !!deal.source;
  const [f, setF] = useState({ title: deal.title || "", value: eur(deal.value_cents), stage: deal.stage_id, close: deal.expected_close || "", note: "" });
  const [who, setWho] = useState(contact);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!who) return toast.error("La trattativa deve avere un contatto");
    setBusy(true);
    try {
      await api.put(`/t/${tid}/crm/deals/${deal.id}/details`, { title: f.title.trim(), stage_id: f.stage, expected_close: f.close || "", note: f.note.trim(),
        ...(auto ? {} : { value_cents: toCents(f.value), contact_id: who.id }) });
      toast.success("Trattativa aggiornata"); onSaved();
    } catch (e) { toast.error(crmErr(e, errMsg)); } finally { setBusy(false); }
  };
  const m = deal.money;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-md" data-testid="edit-deal-dialog">
        <DialogHeader><DialogTitle>Modifica trattativa</DialogTitle></DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="sm:col-span-2"><Label className="text-xs">Nome *</Label><Input value={f.title} onChange={set("title")} data-testid="edit-deal-title" /></div>
          <div className="sm:col-span-2"><Label className="text-xs">Contatto *</Label>
            {auto ? <p className="text-sm text-slate-700">{who?.label || "—"} <span className="text-[11px] text-slate-500">(dal cliente dell'ordine/prenotazione)</span></p>
              : <ContactPicker tid={tid} value={who} onChange={setWho} testid="edit-deal-contact" />}</div>
          {stages.length > 0 && <div><Label className="text-xs">Stato</Label><Select value={f.stage} onValueChange={(v) => setF({ ...f, stage: v })}>
            <SelectTrigger data-testid="edit-deal-stage"><SelectValue /></SelectTrigger><SelectContent>{stages.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent></Select></div>}
          <div><Label className="text-xs">Valore opportunità €</Label>
            {auto ? <p className="pt-2 text-sm tabular-nums">{money(deal.value_cents)}</p> : <Input value={f.value} onChange={set("value")} inputMode="decimal" placeholder="0" data-testid="edit-deal-value" />}</div>
          <div><Label className="text-xs">Chiusura prevista</Label><div><DateField label="Chiusura prevista" value={f.close} onChange={(v) => setF({ ...f, close: v })} testid="edit-deal-close" /></div></div>
          <div className="sm:col-span-2"><Label className="text-xs">Note (facoltative)</Label><Textarea rows={2} value={f.note} onChange={set("note")} data-testid="edit-deal-note" /></div>
        </div>
        {m && <p className="rounded-md bg-slate-50 p-2 text-[11px] text-slate-600" data-testid="edit-deal-money">Revenue {money(m.revenue)} · Incassato {money(m.cash)} — non cambiano con questa modifica: {auto ? "per correggerli usa «Rettifica»." : "si modificano nelle caselle della tabella o con «Rettifica»."}</p>}
        <DialogFooter><Button variant="outline" onClick={onClose}>Annulla</Button><Button onClick={save} disabled={busy || !f.title.trim() || !who} data-testid="edit-deal-save">Salva modifiche</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
